import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { ShippingService } from 'src/core/services/shipping.service';
import { WaybillOrderData,WaybillOrderApiResponse } from 'src/interfaces/waybill';

@Component({
    selector: 'core-waybill-review-orders',
    templateUrl: './waybill-review-orders.component.html',
    styleUrls: ['./waybill-review-orders.component.scss'],
    standalone: false
})
export class WaybillReviewOrdersComponent implements OnInit {

  constructor(private route: ActivatedRoute,private _shippingService: ShippingService) { }

  waybillNumber:string = '';
  waybillData:WaybillOrderData[] = [];
  displayedColumns: string[] = [ 'order_number', 'customer_order_number', 'company_name', 'product', 'total_quantity', 'date_shipped'];

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.waybillNumber = params['waybill']; // get the waybill number from the path
      
      this.getWaybillOrders(this.waybillNumber)
    });
  }
  // get the order details from the waybill number
  async getWaybillOrders(waybillNumber:string) {      
      const response: WaybillOrderApiResponse = await this._shippingService
        .getWayBillOrders(waybillNumber); 
      
      this.waybillData = response.data;
    
    }
  
}
